!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react")) : "function" == typeof define && define.amd ? define(["react"], t) : "object" == typeof exports ? exports["byte-converter"] = t(require("react")) : e["byte-converter"] = t(e.react);
}(window, function (e) {
  return function (e) {
    var t = {};
    function r(n) {
      if (t[n]) return t[n].exports;
      var o = t[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
    }
    return r.m = e, r.c = t, r.d = function (e, t, n) {
      r.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: n
      });
    }, r.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, r.t = function (e, t) {
      if (1 & t && (e = r(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var n = Object.create(null);
      if (r.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) r.d(n, o, function (t) {
        return e[t];
      }.bind(null, o));
      return n;
    }, r.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return r.d(t, "a", t), t;
    }, r.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, r.p = "", r(r.s = 2);
  }([function (e, t, r) {
    e.exports = r(3)();
  }, function (t, r) {
    t.exports = e;
  }, function (e, t, r) {
    "use strict";

    r.r(t);
    var n = r(1),
      o = r.n(n),
      i = r(0),
      a = r.n(i),
      c = {
        B: {
          conversionFactor: 0,
          suffix: "byte"
        },
        KB: {
          conversionFactor: 1,
          suffix: "kilobyte"
        },
        MB: {
          conversionFactor: 2,
          suffix: "megabyte"
        },
        GB: {
          conversionFactor: 3,
          suffix: "gigabyte"
        },
        TB: {
          conversionFactor: 4,
          suffix: "terabyte"
        },
        PB: {
          conversionFactor: 5,
          suffix: "petabyte"
        },
        b: {
          conversionFactor: 0,
          suffix: "bit"
        }
      },
      s = function s(e) {
        var t = e.children,
          r = e.hideWarnings,
          n = e.useSI,
          i = e.suffix,
          a = e.addCommas,
          s = e.inUnit,
          u = e.outUnit,
          f = Number(t),
          p = Number.isInteger(f),
          l = Number.isFinite(f),
          y = f > 0,
          b = Number.isNaN(f);
        r || (Object.prototype.hasOwnProperty.call(c, s) || console.warn("ByteConvert has recieved invalid inUnit prop."), Object.prototype.hasOwnProperty.call(c, s) || console.warn("ByteConvert has recieved invalid inUnit prop."), p || console.warn("ByteConverter must recieve an integer as a child."), l || console.warn("ByteConverter must recieve a finite integer as a child."), y || console.warn("ByteConverter must recieve a positive integer as a child."), b && console.warn("ByteConverter must recieve a number or valid number as a string as a child")), "b" === s && (f /= 8);
        var d = f * (n ? Math.pow(1e3, c[s].conversionFactor) : Math.pow(1024, c[s].conversionFactor)) / (n ? Math.pow(1e3, c[u].conversionFactor) : Math.pow(1024, c[u].conversionFactor));
        "b" === u && (d *= 8), a && (d = d.toLocaleString());
        var v = i ? " ".concat(c[u].suffix).concat(1 === d ? "" : "s") : null;
        return o.a.createElement(o.a.Fragment, null, d, v);
      };
    s.propTypes = {
      children: a.a.oneOfType([a.a.string, a.a.number]).isRequired,
      hideWarnings: a.a.bool,
      useSI: a.a.bool,
      suffix: a.a.bool,
      addCommas: a.a.bool,
      inUnit: a.a.oneOf(Object.keys(c)),
      outUnit: a.a.oneOf(Object.keys(c))
    }, s.defaultProps = {
      hideWarnings: !1,
      useSI: !1,
      suffix: !1,
      addCommas: !1,
      inUnit: Object.keys(c)[0],
      outUnit: Object.keys(c)[2]
    }, t.default = s;
  }, function (e, t, r) {
    "use strict";

    var n = r(4);
    function o() {}
    e.exports = function () {
      function e(e, t, r, o, i, a) {
        if (a !== n) {
          var c = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw c.name = "Invariant Violation", c;
        }
      }
      function t() {
        return e;
      }
      e.isRequired = e;
      var r = {
        array: e,
        bool: e,
        func: e,
        number: e,
        object: e,
        string: e,
        symbol: e,
        any: e,
        arrayOf: t,
        element: e,
        instanceOf: t,
        node: e,
        objectOf: t,
        oneOf: t,
        oneOfType: t,
        shape: t,
        exact: t
      };
      return r.checkPropTypes = o, r.PropTypes = r, r;
    };
  }, function (e, t, r) {
    "use strict";

    e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }]);
});